import { LogoutOutlined } from '@mui/icons-material'
import {IconButton, Menu, MenuItem } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import { logOut } from '../../../store/slice/authSlice'

const Logout = () => {

  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(logOut());
    window.location.href = "/login";
    localStorage.removeItem("reviseId")
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick} aria-label="log-out" color="inherit">
        <LogoutOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
}

export default Logout

